import { css } from '@emotion/core';
import { StackView } from 'localmed-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '../../shared/components/DiComponents';
import { BackButton } from '../pages/SchedulingPage/components/styles';

type Topic = 'cancel' | 'reschedule';

interface Props {
  phone: string;
  done: () => void;
  topic?: Topic;
}

export default function SchedulingApptIsDisabled({ phone, done, topic = 'cancel' }: Props) {
  return (
    <StackView
      spacing="xl"
      css={css`
        text-align: center;
      `}
      mt="lg"
    >
      <Alert type="warning" p="md" my="md">
        <FormattedMessage
          id="scheduling.SchedulingApptIsDisabled.appointmentDisabled"
          defaultMessage="At this time we are not allowing you to {topic} an appointment online. Please call {phone} if you would like to {topic} this appointment."
          values={{
            phone,
            topic,
          }}
        />
      </Alert>

      <BackButton onClick={done} variant="subtle" size="xl">
        <FormattedMessage
          id="scheduling.SchedulingApptIsDisabled.keepAppointmentButton"
          defaultMessage="Done"
        />
      </BackButton>
    </StackView>
  );
}
